import { defaultSubCoverTextStyle, subCoverMap } from "@/pages/sub-cover/js/sub-cover-static";

export const subCover = {
  namespaced: true,
  state: {
    subCoverData: JSON.parse(JSON.stringify(subCoverMap)),
    subCoverDataList: [],
    subCoverBackgrounds: [],
    subCoverTextStyles: [],
  },
  mutations: {
    updateSubCoverData(state, map) {
      Object.assign(state.subCoverData, map);
    },
    setSubCoverMaterials(state, { backgrounds }) {
      state.subCoverBackgrounds = backgrounds || [];
    },
    setSubCoverTextStyles(state, textStyles) {
      state.subCoverTextStyles = textStyles || [];
      if (!state.subCoverData.textStyle.length) {
        state.subCoverData.textStyle = JSON.parse(JSON.stringify(defaultSubCoverTextStyle.styles));
      }
    },
    updateSubCoverDataList(state, map = {}) {
      const { num, list, isClearSubCoverDataList, index, textValue } = map;
      if (isClearSubCoverDataList) state.subCoverDataList = [];
      if (num) {
        for (let i = 0; i < num; i++) {
          const sourceData = state.subCoverDataList[0] || state.subCoverData;
          state.subCoverDataList.push(JSON.parse(JSON.stringify(sourceData)));
        }
        return;
      }
      if (list && list.length) {
        state.subCoverDataList.push(...JSON.parse(JSON.stringify(list)));
        return;
      }
      if (index !== undefined && textValue) {
        state.subCoverDataList[index].textValue = textValue;
        return;
      }
      state.subCoverDataList.forEach(item => {
        Object.assign(item, map);
      });
    },
    deleteSubCoverData(state, index) {
      state.subCoverDataList.splice(index, 1);
    },
    clearSubCoverCacheInfo(state) {
      state.subCoverData = JSON.parse(JSON.stringify(subCoverMap));
      state.subCoverDataList = [];
      state.subCoverBackgrounds = [];
      state.subCoverTextStyles = [];
    },
  },
};
